/* eslint-disable @atlassian/tangerine/import/entry-points */

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
import React, { memo } from 'react';
import Box from '@atlaskit/ds-explorations/box';
import Text from '@atlaskit/ds-explorations/text';

/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */
var Lozenge = /*#__PURE__*/memo(function (_ref) {
  var children = _ref.children,
      testId = _ref.testId,
      _ref$isBold = _ref.isBold,
      isBold = _ref$isBold === void 0 ? false : _ref$isBold,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
  var appearanceStyle = isBold ? 'bold' : 'subtle';
  var appearanceType = appearance in backgroundColors[appearanceStyle] ? appearance : 'default';
  var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
  return /*#__PURE__*/React.createElement(Box, {
    as: "span",
    display: "inlineFlex",
    backgroundColor: backgroundColors[appearanceStyle][appearanceType],
    borderRadius: "normal",
    paddingInline: "scale.050",
    position: "static",
    testId: testId,
    UNSAFE_style: {
      backgroundColor: style.backgroundColor,
      verticalAlign: 'baseline',
      maxWidth: '100%'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    as: "span",
    fontSize: "11px",
    fontWeight: "700",
    lineHeight: "16px",
    textTransform: "uppercase",
    color: textColors[appearanceStyle][appearanceType],
    shouldTruncate: true,
    UNSAFE_style: {
      color: style.color,
      width: '100%',
      // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
      maxWidth: "calc(".concat(maxWidthValue, " - ", "var(--ds-scale-100, 8px)", ")") // to negate paddingInline specified on Box above

    },
    testId: testId && "".concat(testId, "--text")
  }, children));
});
Lozenge.displayName = 'Lozenge';
export default Lozenge; // Lozenge colors

var backgroundColors = {
  bold: {
    default: 'neutral.bold',
    inprogress: 'information.bold',
    moved: 'warning.bold',
    new: 'discovery.bold',
    removed: 'danger.bold',
    success: 'success.bold'
  },
  subtle: {
    default: 'neutral',
    inprogress: 'information',
    moved: 'warning',
    new: 'discovery',
    removed: 'danger',
    success: 'success'
  }
};
var textColors = {
  bold: {
    default: 'inverse',
    inprogress: 'inverse',
    moved: 'warning.inverse',
    new: 'inverse',
    removed: 'inverse',
    success: 'inverse'
  },
  subtle: {
    default: 'subtle',
    inprogress: 'information',
    moved: 'warning',
    new: 'discovery',
    removed: 'danger',
    success: 'success'
  }
};